/* design-light · „Poslat objednávku" — two-tier cart gate + draft-order modal.
 * rev 5.2 (2026-08-01) · contract v1.2.1 · UI copy is dash-free per Hynek
 *  - ≥ 20 000 Kč / 800 €  → button appears ABOVE the checkout button (optional
 *                            invoice-friendly path; Hynek's final numbers)
 *  - ≥ 80 000 Kč / 3 200 € → checkout button hidden, this becomes the only path (+ note)
 * Creates a Shopify draft order via the Supabase edge function `order-request`.
 * Montáž section mirrors snippets/dl-montaz-cart.liquid keys EXACTLY (contract §2.3).
 */
(function () {
  'use strict';
  if (window.__dlOrderInit) return;
  window.__dlOrderInit = true;

  var CFG = window.DLOrderConfig || {};
  var ENDPOINT = CFG.endpoint || '';
  if (!ENDPOINT) { console.warn('[dl-order] missing endpoint'); return; }

  // Thresholds in MINOR units per currency (cart.js reports minor units).
  var TIERS = {
    CZK: { show: 2000000, replace: 8000000 },
    EUR: { show: 80000, replace: 320000 }
  };

  var MZ_KEYS = [
    'Montáž - adresa instalace',
    'Montáž - výška stropu',
    'Montáž - smart home',
    'Montáž - termín',
    'Montáž - odstranění stávajících',
    'Montáž - poznámka'
  ];
  var MZ_MASTER = 'Montáž';
  var MZ_MASTER_YES = 'ANO, poslat cenovou nabídku';

  var cartState = null; // last /cart.js payload
  var fetchTimer = null;

  // ------------------------------------------------------------------ utils
  function money(minor, currency) {
    var v = Math.round(minor / 100);
    try {
      return v.toLocaleString('cs-CZ') + (currency === 'EUR' ? ' €' : ' Kč');
    } catch (e) { return v + ' ' + currency; }
  }

  function tierFor(cart) {
    if (!cart || !cart.item_count) return 0;
    var t = TIERS[cart.currency] || TIERS.CZK;
    if (cart.total_price >= t.replace) return 2;
    if (cart.total_price >= t.show) return 1;
    return 0;
  }

  function fetchCart(cb) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartState = c; if (cb) cb(c); })
      .catch(function () { /* keep last state */ });
  }

  function scheduleRefresh() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () { fetchCart(applyGate); }, 250);
  }

  // -------------------------------------------------------------- injection
  // Anchors (validated live 2026-07-31):
  //  drawer:    form.drawer__footer-buttons  > button[name="checkout"]
  //  cart page: .cart__footer--buttons       > button[name="checkout"]
  function anchors() {
    var out = [];
    document.querySelectorAll('form.drawer__footer-buttons, .cart__footer--buttons')
      .forEach(function (holder) {
        var btn = holder.querySelector('button[name="checkout"]');
        if (btn) out.push({ holder: holder, checkout: btn });
      });
    return out;
  }

  function ensureButton(anchor, tier) {
    var btn = anchor.holder.querySelector('.dl-order-btn');
    var note = anchor.holder.querySelector('.dl-order-note');

    if (tier === 0) {
      if (btn) btn.remove();
      if (note) note.remove();
      anchor.checkout.classList.remove('dl-order-hidden');
      return;
    }

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn dl-order-btn';
      btn.innerHTML = '<span>Poslat objednávku</span>' +
        '<small>Na fakturu, bez okamžité platby</small>';
      btn.addEventListener('click', openModal);
      // ABOVE the buy button:
      anchor.checkout.parentElement.insertBefore(btn, anchor.checkout);
    }

    if (tier === 2) {
      anchor.checkout.classList.add('dl-order-hidden');
      btn.classList.add('dl-order-btn--solo');
      if (!note) {
        note = document.createElement('p');
        note.className = 'dl-order-note';
        anchor.holder.appendChild(note);
      }
      var lim = (cartState && cartState.currency === 'EUR') ? '3 200 €' : '80 000 Kč';
      note.textContent = 'Objednávky nad ' + lim + ' vyřizujeme osobně. Pošlete nám ji ' +
        'jedním kliknutím. Ozveme se do 24 hodin s potvrzením, dopravou a platebními údaji.';
    } else {
      anchor.checkout.classList.remove('dl-order-hidden');
      btn.classList.remove('dl-order-btn--solo');
      if (note) note.remove();
    }
  }

  function applyGate() {
    var tier = tierFor(cartState);
    anchors().forEach(function (a) { ensureButton(a, tier); });
  }

  // ----------------------------------------------------------------- montáž
  // Prefill order of truth: live cart montáž node (freshest, may hold un-saved
  // keystrokes) → cart.attributes from /cart.js.
  function montazPrefill() {
    var vals = {};
    var on = false;
    var node = document.querySelector('.dl-mz-cart');
    if (node) {
      var t = node.querySelector('#dlMzToggle');
      on = !!(t && t.checked);
      node.querySelectorAll('[data-mz]').forEach(function (el) {
        vals[el.getAttribute('data-mz')] = el.value || '';
      });
      var groups = {};
      node.querySelectorAll('[data-mz-group]').forEach(function (el) {
        var g = el.getAttribute('data-mz-group');
        if (!(g in groups)) groups[g] = [];
        if (el.checked) groups[g].push(el.value);
      });
      Object.keys(groups).forEach(function (g) { vals[g] = groups[g].join(', '); });
    } else if (cartState && cartState.attributes) {
      on = cartState.attributes[MZ_MASTER] === MZ_MASTER_YES;
      MZ_KEYS.forEach(function (k) { vals[k] = cartState.attributes[k] || ''; });
    }
    return { on: on, vals: vals };
  }

  // ------------------------------------------------------------------ modal
  var modal = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'dl-order-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="dlo-overlay" data-dlo-close></div>' +
      '<div class="dlo-panel" role="dialog" aria-modal="true" aria-labelledby="dloTitle">' +
        '<button type="button" class="dlo-close" data-dlo-close aria-label="Zavřít">×</button>' +
        '<div class="dlo-scroll">' +
          '<h2 id="dloTitle">Poslat objednávku</h2>' +
          '<p class="dlo-sub">Nezávazně a bez okamžité platby. Objednávku projdeme a do 24 hodin ' +
            'se ozveme s potvrzením, termínem dodání a platebními údaji (bankovní převod).</p>' +
          '<form class="dlo-form" novalidate>' +
            '<input type="text" name="hp" class="dlo-hp" tabindex="-1" autocomplete="off" aria-hidden="true">' +
            '<div class="dlo-grid">' +
              '<label class="dlo-full">Jméno a příjmení *<input type="text" name="name" required autocomplete="name"></label>' +
              '<label class="dlo-full">Firma / IČ<input type="text" name="company" autocomplete="organization" placeholder="nepovinné, vyplňte pro nákup na firmu"></label>' +
              '<label>E-mail *<input type="email" name="email" required autocomplete="email"></label>' +
              '<label>Telefon<input type="tel" name="phone" autocomplete="tel" placeholder="nepovinné"></label>' +
              '<label class="dlo-full">Ulice a č. p. *<input type="text" name="street" required autocomplete="street-address"></label>' +
              '<label>Město *<input type="text" name="city" required autocomplete="address-level2"></label>' +
              '<label>PSČ *<input type="text" name="zip" required autocomplete="postal-code"></label>' +
              '<label class="dlo-full">Země' +
                '<select name="country">' +
                  '<option value="CZ" selected>Česko</option>' +
                  '<option value="SK">Slovensko</option>' +
                  '<option value="other">Jiná (upřesníme e-mailem)</option>' +
                '</select></label>' +
              '<label>Urgence dodání (do kdy svítidla potřebujete)<input type="date" name="urgencyDate"></label>' +
              '<label>Poznámka k termínu<input type="text" name="urgencyNote" placeholder="všední dny v dopoledních hodinách"></label>' +
            '</div>' +
            '<div class="dlo-mz">' +
              '<label class="dlo-mz-head">' +
                '<input type="checkbox" name="mzToggle">' +
                '<span class="dlo-mz-box" aria-hidden="true"></span>' +
                '<span class="dlo-mz-tx"><b>Poptat montáž, pošleme cenovou nabídku</b>' +
                '<span>Nezávazně. Nabídku montáže od našich elektrikářů dostanete zvlášť.</span></span>' +
              '</label>' +
              '<div class="dlo-mz-fields" hidden>' +
                '<div class="dlo-grid">' +
                  '<label>Adresa instalace<input type="text" data-mz="Montáž - adresa instalace" placeholder="ulice, město"></label>' +
                  '<label>Výška stropu<input type="text" data-mz="Montáž - výška stropu" placeholder="např. 2,7 m"></label>' +
                  '<label>Smart home systém<select data-mz="Montáž - smart home">' +
                    '<option value="Ne" selected>Ne</option>' +
                    '<option value="Ano">Ano (napíšeme si detaily)</option></select></label>' +
                  '<label>Představa termínu montáže<input type="text" data-mz="Montáž - termín" placeholder="např. druhá půlka srpna"></label>' +
                '</div>' +
                '<fieldset class="dlo-mz-checks"><legend>Odstranění stávajících svítidel</legend>' +
                  '<label><input type="checkbox" data-mz-group="Montáž - odstranění stávajících" value="Demontáž stávajících svítidel"><span class="dlo-mz-box" aria-hidden="true"></span><span>Demontáž stávajících svítidel</span></label>' +
                  '<label><input type="checkbox" data-mz-group="Montáž - odstranění stávajících" value="Odvoz a likvidace stávajících svítidel"><span class="dlo-mz-box" aria-hidden="true"></span><span>Odvoz a likvidace stávajících svítidel</span></label>' +
                '</fieldset>' +
                '<label class="dlo-full">Poznámka k montáži<textarea data-mz="Montáž - poznámka" rows="2" placeholder="přístup, počet svítidel…"></textarea></label>' +
              '</div>' +
            '</div>' +
            '<p class="dlo-summary"></p>' +
            '<p class="dlo-error" hidden></p>' +
            '<button type="submit" class="btn dlo-submit"><span>Odeslat objednávku</span></button>' +
            '<p class="dlo-legal">Odesláním nic neplatíte a k ničemu se nezavazujete. Košík vám zůstane.</p>' +
          '</form>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-dlo-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    var toggle = modal.querySelector('input[name="mzToggle"]');
    toggle.addEventListener('change', function () {
      modal.querySelector('.dlo-mz-fields').hidden = !toggle.checked;
    });
    modal.querySelector('.dlo-form').addEventListener('submit', onSubmit);

    // Date picker: today as minimum.
    var d = new Date();
    var iso = d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
    modal.querySelector('input[name="urgencyDate"]').min = iso;
    return modal;
  }

  function openModal() {
    buildModal();
    // carry over montáž values from the cart form
    var pre = montazPrefill();
    var toggle = modal.querySelector('input[name="mzToggle"]');
    toggle.checked = pre.on;
    modal.querySelector('.dlo-mz-fields').hidden = !pre.on;
    modal.querySelectorAll('[data-mz]').forEach(function (el) {
      var v = pre.vals[el.getAttribute('data-mz')];
      if (v !== undefined && v !== '') el.value = v;
    });
    var odstr = pre.vals['Montáž - odstranění stávajících'] || '';
    modal.querySelectorAll('[data-mz-group]').forEach(function (el) {
      el.checked = odstr.indexOf(el.value) !== -1;
    });
    var sum = modal.querySelector('.dlo-summary');
    if (cartState) {
      sum.textContent = 'Objednávka: ' + cartState.item_count + ' ks · ' +
        money(cartState.total_price, cartState.currency) +
        (cartState.currency === 'CZK' ? ' vč. DPH' : '');
    }
    modal.querySelector('.dlo-error').hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('dl-order-modal-open');
    var first = modal.querySelector('input[name="name"]');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('dl-order-modal-open');
  }

  // ----------------------------------------------------------------- submit
  var ERRORS = {
    below_threshold: 'Hodnota košíku je pod hranicí pro tento typ objednávky. Dokončete prosím nákup přes „Zaplatit".',
    invalid_email: 'Zkontrolujte prosím e-mail, nevypadá platně.',
    missing_fields: 'Vyplňte prosím jméno a e-mail.',
    empty_cart: 'Košík je prázdný, přidejte prosím zboží.',
    unknown_variant: 'Některá položka v košíku už není dostupná. Obnovte prosím stránku.',
    rate_limited: 'Příliš mnoho pokusů. Zkuste to prosím za chvíli, nebo napište na info@artemide.cz.',
    server_error: 'Něco se pokazilo na naší straně. Zkuste to prosím znovu, nebo napište na info@artemide.cz.',
    shopify_rejected: 'Objednávku se nepodařilo založit. Zkuste to prosím znovu, nebo napište na info@artemide.cz.'
  };

  function collectMontaz() {
    var toggle = modal.querySelector('input[name="mzToggle"]');
    if (!toggle.checked) return null;
    var out = {};
    out[MZ_MASTER] = MZ_MASTER_YES;
    modal.querySelectorAll('[data-mz]').forEach(function (el) {
      out[el.getAttribute('data-mz')] = el.value || '';
    });
    var picked = [];
    modal.querySelectorAll('[data-mz-group]').forEach(function (el) {
      if (el.checked) picked.push(el.value);
    });
    out['Montáž - odstranění stávajících'] = picked.join(', ');
    return out;
  }

  function onSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var errEl = modal.querySelector('.dlo-error');
    errEl.hidden = true;
    if (!form.reportValidity()) return;
    if (!cartState || !cartState.items || !cartState.items.length) {
      errEl.textContent = ERRORS.empty_cart; errEl.hidden = false; return;
    }

    var fd = new FormData(form);
    var montaz = collectMontaz();
    var payload = {
      items: cartState.items.map(function (it) {
        return { variantId: it.variant_id || it.id, quantity: it.quantity, properties: it.properties || null };
      }),
      customer: {
        name: fd.get('name'), company: fd.get('company'), email: fd.get('email'),
        phone: fd.get('phone'), street: fd.get('street'), city: fd.get('city'),
        zip: fd.get('zip'), country: fd.get('country')
      },
      urgency: { date: fd.get('urgencyDate'), note: fd.get('urgencyNote') },
      montaz: montaz,
      token: 'dlo-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10),
      hp: fd.get('hp')
    };

    var btn = modal.querySelector('.dlo-submit');
    btn.disabled = true;
    btn.firstChild.textContent = 'Odesílám…';

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server_error' }; }); })
      .then(function (res) {
        if (res && res.ok) {
          showSuccess(res.draftOrderName, montaz !== null);
          // Keep cart montáž attributes in sync with what was just sent,
          // so a later normal checkout carries the same answers.
          if (montaz) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: montaz })
            }).catch(function () {});
          }
        } else {
          errEl.textContent = ERRORS[(res && res.error) || 'server_error'] || ERRORS.server_error;
          errEl.hidden = false;
          btn.disabled = false;
          btn.firstChild.textContent = 'Odeslat objednávku';
        }
      })
      .catch(function () {
        errEl.textContent = ERRORS.server_error;
        errEl.hidden = false;
        btn.disabled = false;
        btn.firstChild.textContent = 'Odeslat objednávku';
      });
  }

  function showSuccess(draftName, withMontaz) {
    var scroll = modal.querySelector('.dlo-scroll');
    scroll.innerHTML =
      '<div class="dlo-success">' +
        '<div class="dlo-check" aria-hidden="true"></div>' +
        '<h2>Objednávku jsme přijali</h2>' +
        '<p>Číslo: <b>' + esc(draftName) + '</b></p>' +
        '<p>Do 24 hodin (v pracovní dny) se vám ozveme na e-mail s potvrzením, ' +
          'termínem dodání a platebními údaji.' +
          (withMontaz ? ' Nabídku montáže pošleme zvlášť.' : '') + '</p>' +
        '<p class="dlo-legal">Košík vám zůstal beze změny.</p>' +
        '<button type="button" class="btn dlo-submit" data-dlo-close><span>Zavřít</span></button>' +
      '</div>';
  }

  // ------------------------------------------------------------------- boot
  function boot() {
    fetchCart(applyGate);
    ['CartDrawer', 'MainContent'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        new MutationObserver(function (muts) {
          // ignore mutations we caused ourselves
          for (var i = 0; i < muts.length; i++) {
            var t = muts[i].target;
            if (t && t.closest && t.closest('.dl-order-modal')) continue;
            scheduleRefresh();
            return;
          }
        }).observe(el, { childList: true, subtree: true });
      }
    });
    // Cart mutations via AJAX endpoints → re-check totals.
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var p = origFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(scheduleRefresh, function () {});
      }
      return p;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
